import { parseDate, dateDiff } from 'shared-components';

export const addTime = (
  totalTime: number,
  {
    startDate,
    endDate,
  }: {
    startDate: string;
    endDate: string;
  },
) => {
  const momentEndDate = parseDate(endDate);
  const momentStartDate = parseDate(startDate);

  if (!momentEndDate || !momentStartDate) {
    return totalTime;
  }

  const days = dateDiff(momentStartDate, momentEndDate, 'days');

  totalTime += days;
  return totalTime;
};
